export const pricingTypes = ['PER_LOAD', 'PER_KG', 'PER_ITEM', 'FIXED'] as const;
export type PricingType = (typeof pricingTypes)[number];

export const addOnPricingTypes = ['FLAT', 'PER_KG', 'PER_ITEM'] as const;
export type AddOnPricingType = (typeof addOnPricingTypes)[number];

export type Service = {
  id: string;
  name: string;
  category?: string;
  description?: string;
  pricingType: PricingType;
  /** Price expressed as integer centavos. */
  priceCentavos: number;
  minimumKg?: number;
  loadCapacityKg?: number;
  requiresWeight?: boolean;
  requiresItemSelection?: boolean;
  allowsQuantity?: boolean;
  allowsAddons?: boolean;
  active?: boolean;
  sortOrder?: number;
};

export type ServiceItem = {
  id: string;
  serviceId: string;
  name: string;
  /** Item price expressed as integer centavos. */
  unitPriceCentavos: number;
  active?: boolean;
  sortOrder?: number;
};

export type AddOn = {
  id: string;
  name: string;
  pricingType: AddOnPricingType;
  /** Add-on unit price expressed as integer centavos. */
  priceCentavos: number;
  active?: boolean;
  sortOrder?: number;
};

export type SelectedServiceItem = {
  item: ServiceItem;
  quantity: number;
};

export type SelectedAddOn = {
  addOn: AddOn;
  quantity?: number;
};

export type AddOnSelectionSnapshot = {
  readonly addonId: string;
  readonly nameSnapshot: string;
  readonly pricingType: AddOnPricingType;
  /** Historical unit price in integer centavos. */
  readonly unitPriceCentavos: number;
  readonly quantity: number;
  /** Historical total for this add-on selection in integer centavos. */
  readonly lineTotalCentavos: number;
};

export type Discount =
  { type: 'FIXED'; amountCentavos: number } | { type: 'PERCENTAGE'; percentage: number };

export type PricingRequest = {
  service: Service;
  weightKg?: number;
  quantity?: number;
  items?: SelectedServiceItem[];
  addOns?: SelectedAddOn[];
  discount?: Discount;
};

export type PricingResult = {
  baseSubtotalCentavos: number;
  addOnsSubtotalCentavos: number;
  subtotalCentavos: number;
  discountCentavos: number;
  grandTotalCentavos: number;
};
